package com.narbase.letsgo.web.translations

import com.narbase.letsgo.models.Language
import com.narbase.letsgo.web.storage.StorageManager

fun String.localized(vararg params: String): String {
    val key = this.lowercase()

    val getTranslationOrNull = when (StorageManager.language) {
        Language.Ar -> arabicMap[key]
        Language.Fr -> frenchMap[this]
        Language.En -> englishMap[this] ?: this
    }
    var translation = getTranslationOrNull ?: this

    if (getTranslationOrNull == null) {
        console.log("Missing ${StorageManager.language} translation")
        console.log(""""$this" to "",""")
    }

    params.forEach {
        translation = translation.replaceFirst("%s", it)
    }
    return translation
}
